<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-20 md-size-25 md-small-size-0">
			</div>
			<div class="md-layout-item md-medium-size-60 md-size-50 md-small-size-100">

				<md-card>
					<md-card-header data-background-color="purple">

						<h4 class="title"><b>AIR & TECH SHOW Privacy Policy</b></h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<p>Updated at 2021-10-19</p>

<p>AIR & TECH SHOW is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by AIR & TECH SHOW.</p>
<p>This Privacy Policy applies to our website, airandtech.show , and its associated subdomains (collectively, our "Services"). By accessing or using our Services, you signify that you have read, understood, and agreed to our collection, storage, use, and disclosure of your personal information as described in this Privacy Policy and our Terms of Services.</p>
<h2>Definitions and key terms</h2>
<p>

	To help explain things as clearly as possible in this Privacy Policy, every time any of these terms are referenced, are strictly defined as:
		<ul>
			<li><b>Cookie</b>: small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, remember information about you such as your language preference or login information.</li>
			<li><b>Company</b>: when this policy mentions “Company,” “we,” “us,” or “our,” it refers to AIR & TECH SHOW that is responsible for your information under this Privacy Policy.</li>
			<li><b>Country</b>: where AIR & TECH SHOW or the owners/founders of AIR & TECH SHOW are based, in this case is Cambodia.</li>
			<li><b>Customer</b>: refers to the company, organization or person that signs up to use the AIR & TECH SHOW Service to manage the relationships with your consumers or service users.</li>
			<li><b>Device</b>: any internet connected device such as a phone, tablet, computer or any other device that can be used to visit AIR & TECH SHOW and use the services.</li>
			<li><b>IP address</b>: Every device connected to the Internet is assigned a number known as an Internet protocol (IP) address. These numbers are usually assigned in geographic blocks. An IP address can often be used to identify the location from which a device is connecting to the Internet.</li>
			<li><b>Personnel</b>: refers to those individuals who are employed by AIR & TECH SHOW or are under contract to perform a service on behalf of one of the parties.</li>
			<li><b>Personal</b> Data: any information that directly, indirectly, or in connection with other information — including a personal identification number — allows for the identification or identifiability of a natural person.</li>
			<li><b>Service</b>: refers to the service provided by AIR & TECH SHOW as described in the relative terms (if available) and on this platform.</li>
			<li><b>Third-party service</b>: refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you.</li>
			<li><b>Website</b>: AIR & TECH SHOW’s site, which can be accessed via this URL: airandtech.show.</li>
			<li><b>You</b>: a person or entity that is registered with AIR & TECH SHOW to use the Services.</li>
		</ul>
	</p>
<h2>What Information Do We Collect?</h2>
<p>
	We collect information from you when you fill out a form.

		 <ul>
			 <li>Name / Username</li>
			 <li>Phone Number</li>
			 <li>Email Address</li>
			 <li>ID Card / Document</li>
			 <li>Vaccination Card</li>
			 <li>Selfie Photo</li>
		 </ul>

		 We also collect information from mobile devices for a better user experience, although these features are completely optional:

		 <ul>
			 <li><b>Camera (Pictures)</b>: Granting camera permission allows the user to upload any picture straight to our services.</li>
			 <li><b>Photo Gallery (Pictures)</b>: Granting photo gallery access allows the user to upload any picture from their photo gallery to our services.</li>
		 </ul>


	</p>
<h2>How Do We Use The Information We Collect?</h2>

<p>Any of the information we collect from you may be used in one of the following ways:

	<ul>
		<li>To personalise your experience (your information helps us to better respond to your individual needs)</li>
		<li>To improve our services (we continually strive to improve our service offerings based on the information and feedback we receive from you)</li>
		<li>To process transactions</li>
		<li>To administer a contest, survey or other site features</li>
	</ul>



	</p>

<h2>How Do We Use Your Email Address?</h2>
By submitting your email address on our services, you agree to receive emails from us. You can cancel your participation on any of these email lists at any time by clicking on the opt-out link or other unsubscribe option that is included in the respective email. We only send emails to people who have authorised us to contact them, either directly, or through a third party. We do not send unsolicited commercial emails, because we hate spam as much as you do.

<h2>Could my information be transferred to other countries?</h2>
We are incorporated in Cambodia. Information collected via our website, through direct interactions with you, or from use of our help services may be transferred from time to time to our offices or personnel, or to third parties, located throughout the world, and may be viewed and hosted anywhere in the world, including countries that may not have laws of general applicability regulating the use and transfer of such data. To the fullest extent allowed by applicable law, by using any of the above, you voluntarily consent to the trans- border transfer and hosting of such information.
<h2>Is the information collected through our service secure?</h2>
We take precautions to protect the security of your information. We have physical, electronic, and managerial procedures to help safeguard, prevent unauthorised access, maintain data security, and correctly use your information. However, neither people nor security systems are foolproof, including encryption systems. In addition, people can commit national or intentional crimes, make mistakes or fail to follow policies. Therefore, while we use reasonable efforts to protect your personal information, we cannot guarantee its absolute security. If applicable law imposes any non-disclaimable duty to protect your personal information, you agree that national or intentional misconduct will be the standards used to measure our compliance with that duty.

<h2>How Long Do We Keep Your Information?</h2>
We keep your information only so long as we need it to provide services to you and fulfill the purposes described in this policy. This is also the case for anyone that we share your information with and who carries out services on our behalf. When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we'll either remove it from our systems or depersonalise it so that we can't identify you.

<h2>How Do We Protect Your Information?</h2>
We implement a variety of security measures to maintain the safety of your personal information when you place an order or enter, submit, or access to your personal information. We offer the use of a secure server. All supplied sensitive information is transmitted via Secure Socket Layer (SSL) technology and then encrypted into our server database only to be accessible by those authorised with special access rights to such systems, and are required to keep the information confidential. After a transaction, your private information (ID card, vaccination card, address, etc.) is never kept on file.

<h2>Cookies</h2>
We use "Cookies" to identify the areas of our website that you have visited. A Cookie is a small piece of data stored on your computer or mobile device by your web browser. We use Cookies to personalise the Content that you see on our website. Most web browsers can be set to disable the use of Cookies. However, if you disable Cookies, you may not be able to access functionality on our website correctly or at all. We never place Personally Identifiable Information in Cookies.

<h2>Changes To Our Privacy Policy</h2>
If we decide to change our privacy policy, we will post those changes on this page, and/or update the Privacy Policy modification date below.

<h2>Tracking Technologies</h2>
<ul>
	<li><b>Cookies</b><br>
		We use Cookies to enhance the performance and functionality of our service but are non-essential to their use. However, without these cookies, certain functionality like videos may become unavailable or you would be required to enter your login details every time you visit our service as we would not be able to remember that you had logged in previously.
		</li>
	<li><b>Local Storage</b><br>
		Local Storage sometimes known as DOM storage, provides web apps with methods and protocols for storing client-side data. Web storage supports persistent data storage, similar to cookies but with a greatly enhanced capacity and no information stored in the HTTP request header.
		</li>
</ul>

<h2>Your Consent</h2>
Hereby, you guarantee and confirm that you have provided true information in our form. By using our services, registering an account, or making a purchase, you consent to this Privacy Policy.

<h2>Governing Law</h2>
<p>The laws of Cambodia, excluding its conflicts of law rules, shall govern this Agreement and Your Use of Our Services. Your use of our services may also be subject to other local, state, national, or international laws.</p>
<br>
<p>*Don't hesitate to contact us if you have any questions via Email: airandtechshowinfo@gmail.com</p>






						</p>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/PrivacyPolicy.vue